import React from 'react';
import styled from 'styled-components';
import { OnlineThemeType, ThemeColors } from '../../../themes/online';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SLegalText = styled.div<{ padding?: string }>(
  ({ theme, padding, color }) => `
  display:block;
  font-size: ${theme.font.size.smallMedium};
  font-weight: ${theme.font.weight.light};
  color: ${color ? theme.colors[color] : theme.colors.grayDark};
  text-align: justify;
  padding: ${padding};
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface ILegalTextProps {
  dataAt: string;
  className?: string;
  padding?: string;
  tabIndexProp?: number;
  color?: ThemeColors;
  id?: string;
}

// tslint:disable-next-line:variable-name
const LegalText: React.FC<ILegalTextProps> = (props) => (
  <SLegalText color={props.color} id={props.id || ''} tabIndex={props.tabIndexProp || 0} padding={props.padding} className={props.className} data-at={props.dataAt}>
    {props.children}
  </SLegalText>
);

export default LegalText;
